import { createBrowserRouter, Navigate, Outlet, useRouteError } from 'react-router';
import { AuthSzolgaltato } from './auth/AuthAllapot.tsx';
import VedettUt from './auth/VedettUt.tsx';
import { AktivIrodaSzolgaltato } from './iroda/AktivIroda.tsx';
import Keret from './keret/Keret.tsx';
import SuperKapu from './keret/SuperKapu.tsx';
import Belepes from './oldalak/Belepes.tsx';
import BelepesMegerosites from './oldalak/BelepesMegerosites.tsx';
import Elemzes from './oldalak/Elemzes.tsx';
import HibajelentesAdatlap from './oldalak/HibajelentesAdatlap.tsx';
import Hibajelentesek from './oldalak/Hibajelentesek.tsx';
import Kollegak from './oldalak/Kollegak.tsx';
import LeadAdatlap from './oldalak/LeadAdatlap.tsx';
import LeadLista from './oldalak/LeadLista.tsx';
import Mfa from './oldalak/Mfa.tsx';
import NincsOldal from './oldalak/NincsOldal.tsx';
import Profil from './oldalak/Profil.tsx';
import Regisztracio from './oldalak/Regisztracio.tsx';
import RegisztracioMegerosites from './oldalak/RegisztracioMegerosites.tsx';
import SuperFelhasznalok from './oldalak/SuperFelhasznalok.tsx';
import SuperIrodaSzerkeszto from './oldalak/SuperIrodaSzerkeszto.tsx';
import SuperIrodak from './oldalak/SuperIrodak.tsx';
import SuperMinoseg from './oldalak/SuperMinoseg.tsx';
import SuperOutbox from './oldalak/SuperOutbox.tsx';
import SuperRegisztracio from './oldalak/SuperRegisztracio.tsx';
import SuperRegisztraciok from './oldalak/SuperRegisztraciok.tsx';
import Weboldal from './oldalak/Weboldal.tsx';

function HibaOldal() {
  const hiba = useRouteError();
  const szoveg = hiba instanceof Error ? hiba.message : typeof hiba === 'object' && hiba && 'message' in hiba ? String(hiba.message) : String(hiba);
  return (
    <main className="mx-auto grid min-h-dvh max-w-lg content-center gap-3 p-5">
      <h1 className="text-2xl font-semibold">Hiba történt</h1>
      <p>Hiba történt. Frissítsd az oldalt; ha újra előjön, szólj nekünk.</p>
      <pre className="overflow-auto rounded-[var(--sarok-s)] bg-hiba-hatter p-3 text-sm text-hiba whitespace-pre-wrap">{szoveg}</pre>
    </main>
  );
}

function AuthKeret() {
  return <AuthSzolgaltato><Outlet /></AuthSzolgaltato>;
}

function VedettKeret() {
  return <AktivIrodaSzolgaltato><Keret /></AktivIrodaSzolgaltato>;
}

export const router = createBrowserRouter([
  {
    errorElement: <HibaOldal />,
    children: [
      // Nyilvános oldalak: belépés nélkül érhetők el, ezért az AuthKeret (munkamenet-kezelés) és a VedettUt kívül vannak.
      { path: '/regisztracio', element: <Regisztracio /> },
      { path: '/regisztracio/megerosites', element: <RegisztracioMegerosites /> },
      {
        element: <AuthKeret />,
        children: [
          { path: '/belepes', element: <Belepes /> },
          { path: '/belepes/megerosites', element: <BelepesMegerosites /> },
          { path: '/belepes/mfa', element: <Mfa /> },
          {
            element: <VedettUt />,
            children: [
              {
                element: <VedettKeret />,
                children: [
                  { path: '/', element: <Navigate replace to="/leadek" /> },
                  { path: '/leadek', element: <LeadLista /> },
                  { path: '/leadek/:id', element: <LeadAdatlap /> },
                  { path: '/elemzes', element: <Elemzes /> },
                  { path: '/hibajelentesek', element: <Hibajelentesek /> },
                  { path: '/hibajelentesek/:id', element: <HibajelentesAdatlap /> },
                  { path: '/kollegak', element: <Kollegak /> },
                  { path: '/weboldal', element: <Weboldal /> },
                  { path: '/profil', element: <Profil /> },
                  {
                    element: <SuperKapu />,
                    children: [
                      { path: '/super/irodak', element: <SuperIrodak /> },
                      { path: '/super/irodak/uj', element: <SuperIrodaSzerkeszto /> },
                      { path: '/super/irodak/:id', element: <SuperIrodaSzerkeszto /> },
                      { path: '/super/felhasznalok', element: <SuperFelhasznalok /> },
                      { path: '/super/minoseg', element: <SuperMinoseg /> },
                      { path: '/super/outbox', element: <SuperOutbox /> },
                      { path: '/super/regisztraciok', element: <SuperRegisztraciok /> },
                      { path: '/super/regisztraciok/:id', element: <SuperRegisztracio /> },
                    ],
                  },
                  { path: '*', element: <NincsOldal /> },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
]);
